import React from 'react';

export default React.memo(function Title({ className = '', children }) {
  return (
    <span className={`text-center text-black text-3xl font-medium whitespace-pre-line select-none ${className}`}>{children}</span>
  );
})
